import type {
    SaurusKey
} from "../../core/saurusAllocation.js";
import type {
    DinoAssistantState
} from "../../assets/dino-assistant/dinoAssistantAssets.js";

const saurusPresentations: Record<
    SaurusKey,
    {
        state: DinoAssistantState;
        icon: string;
        labelKey:
            | "saurus.velociraptor.name"
            | "saurus.triceratops.name"
            | "saurus.brachiosaurus.name";
        traitKey:
            | "saurus.velociraptor.trait"
            | "saurus.triceratops.trait"
            | "saurus.brachiosaurus.trait";
    }
> = {
    "velociraptor-explorer": {
        state: "vision",
        icon: "⚡",
        labelKey:
            "saurus.velociraptor.name",
        traitKey:
            "saurus.velociraptor.trait"
    },
    "triceratops-perseverant": {
        state: "success",
        icon: "🛡️",
        labelKey:
            "saurus.triceratops.name",
        traitKey:
            "saurus.triceratops.trait"
    },
    "brachiosaurus-curious": {
        state: "thinking",
        icon: "💡",
        labelKey:
            "saurus.brachiosaurus.name",
        traitKey:
            "saurus.brachiosaurus.trait"
    }
};

export {
    saurusPresentations
};
